import React from 'react';

import { Tooltip } from '@vlabs/uikit';
import cn from 'classnames';

import st from './shared.module.sass';
import { getLunaStreamsStatusConfig } from './streamStatusConfig';

export type StreamStatusLunaStreamsType = 'text' | 'badge';

interface StreamStatusLunaStreamsProps {
  /** Строковый статус luna-streams (pending, in_progress, done, ...). */
  status: string;
  type?: StreamStatusLunaStreamsType;
  testId?: string;
}

function StreamStatusLunaStreams({
  status,
  type = 'text',
  testId = undefined,
}: StreamStatusLunaStreamsProps): React.JSX.Element {
  const streamConfig = getLunaStreamsStatusConfig(status);

  if (type === 'badge') {
    return (
      <Tooltip
        data-testid={testId}
        tooltipContent={streamConfig.label}
        tooltipProps={{ place: 'bottom' }}
      >
        <div className={st.Badge}>
          <div className={cn(st.BadgeInner, streamConfig.colorClass)} />
        </div>
      </Tooltip>
    );
  }

  return (
    <div
      className={st.Pill}
      data-testid={testId}
    >
      <span className={cn(st.PillText, streamConfig.textColorClass)}>
        {streamConfig.label}
      </span>
    </div>
  );
}

export { StreamStatusLunaStreams };
